import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { Link } from "react-router-dom";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";

class EventCharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.update();
  }

  update = async () => {
    this.setState({ pending: true });
    let data = [
      { name: "Сообщ. (М)", value: 0 },
      { name: "Предупр. (W)", value: 0 },
      { name: "Ошибки (E)", value: 0 },
    ];

    await this.context.api
      .tfetch("/admin/event/log/list", {
        reclimit: 150,
        recoffset: 0,
        orderby: ["datetime DESC"],
        fields: ["type"],
      })
      .then(
        (json) => {
          if (json.hasOwnProperty("error")) {
            if (!this.props.quiet)
              this.context.toast(json.error["message"], "warning");
          } else {
            json.forEach((item) => {
              if (item.type === "M") data[0].value++;
              if (item.type === "W") data[1].value++;
              if (item.type === "E") data[2].value++;
            });
          }
        },
        (e) => {
          if (!this.props.quiet) this.context.toast(e.message, "warning");
        }
      );

    this.setState({ data, pending: false });
  };
  label(label) {
    if (label.value > 0) {
      return label.name;
    }
  }
  render() {
    let chartColors = ["#DDDDDD", "#FFBB28", "#FF8042"];
    return (
      <>
        <h5 onClick={this.update} className="text-center">
          Статистика журнала событий
        </h5>
        <div className="text-muted text-center font-size-sm">
          <span className="text-danger">*</span> По последним 150 записям
        </div>
        <div className="d-flex align-items-center justify-content-center h100">
          <Blocker on={this.state.pending}>
            <PieChart width={250} height={250}>
              <Pie
                data={this.state.data}
                cx={125}
                cy={125}
                innerRadius={40}
                outerRadius={60}
                fill="#8884d8"
                paddingAngle={5}
                dataKey="value"
                label={(label) => this.label(label)}
                labelLine={false}
              >
                {this.state.data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={chartColors[index % chartColors.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </Blocker>
        </div>
        <div className="text-center">
          <Link to="/admin/eventLog" className="btn btn-light">
            Перейти в журнал
          </Link>
        </div>
      </>
    );
  }
}
EventCharts.contextType = Context;

export default EventCharts;
